/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
 import JSG from '@cedalo/jsg-ui';

 export default class ShowSheetCommand extends JSG.Command {
	 constructor(streamsheet, visible) {
		 super();
		 this.isVisible = visible;
		 this.streamsheet = streamsheet;
	 }
 
	 execute() {
		 this.redo();
	 }
 
	 undo() {
		 this.streamsheet.isVisible = !this.isVisible;
	 }
 
	 redo() {
		 this.streamsheet.isVisible = this.isVisible;
	 }
 }
 